'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./TargetDateSeriesMethodologyLink.css');

var TargetDateSeriesMethodologyLink = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TargetDateSeriesMethodologyLink, _Component);

  function TargetDateSeriesMethodologyLink(props) {
    (0, _classCallCheck3.default)(this, TargetDateSeriesMethodologyLink);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TargetDateSeriesMethodologyLink.__proto__ || (0, _getPrototypeOf2.default)(TargetDateSeriesMethodologyLink)).call(this, props));

    _this.state = _this.getMethodologyLinkState(props.iyvCode, props.targetDateSeries);
    return _this;
  }

  (0, _createClass3.default)(TargetDateSeriesMethodologyLink, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState(this.getMethodologyLinkState(props.iyvCode, props.targetDateSeries));
    }
  }, {
    key: 'getMethodologyLinkState',
    value: function getMethodologyLinkState(iyvCode, targetDateSeries) {
      var ticker = targetDateSeries.ticker,
          fund_legal_name = targetDateSeries.fund_legal_name,
          fund_id = targetDateSeries.fund_id,
          investment_vehicle_id = targetDateSeries.investment_vehicle_id;


      var sTicker = ticker || 'N';

      var urlBuilder = function urlBuilder(route, profilePath) {
        return route + '/fund/' + _format2.default.sanitize(fund_legal_name) + '/' + sTicker + '/' + profilePath + '/' + fund_id + '/' + investment_vehicle_id;
      };

      var fullProfileUrl = null;
      var fullProfileText = null;
      var methodologyUrl = null;
      switch (iyvCode) {
        case 'fff':
          fullProfileUrl = urlBuilder(_config2.default.links.fff, 'fossil-fuel-investments');
          fullProfileText = 'Fossil Free Funds';
          methodologyUrl = _config2.default.routes.companies + '#fossilfuels';
          break;

        case 'dff':
          methodologyUrl = _config2.default.routes.companies + '#deforestation';
          fullProfileUrl = urlBuilder(_config2.default.links.dff, 'profile');
          fullProfileText = 'Deforestation Free Funds';
          break;

        case 'ffb':
          methodologyUrl = _config2.default.routes.companies + '#fossilfinance';
          fullProfileUrl = urlBuilder(_config2.default.links.fff, 'fossil-finance-insurance');
          fullProfileText = 'Fossil Free Funds';
          break;

        case 'ffi':
          methodologyUrl = _config2.default.routes.companies + '#fossilinsurance';
          fullProfileUrl = urlBuilder(_config2.default.links.fff, 'fossil-finance-insurance');
          fullProfileText = 'Fossil Free Funds';
          break;

        case 'gef':
          // methodologyUrl = config.routes.companies + '#genderequality'
          fullProfileUrl = urlBuilder(_config2.default.links.gef, 'gender-lens-score');
          fullProfileText = 'Gender Equality Funds';
          break;

        case 'gff':
          methodologyUrl = _config2.default.routes.companies + '#civilianfirearms';
          fullProfileUrl = urlBuilder(_config2.default.links.gff, 'gun-investments');
          fullProfileText = 'Gun Free Funds';
          break;

        case 'pff':
          methodologyUrl = _config2.default.routes.companies + '#prisonindustrialcomplex';
          fullProfileUrl = urlBuilder(_config2.default.links.pff, 'prison-industrial-complex-investments');
          fullProfileText = 'Prison Free Funds';
          break;

        case 'wff':
          methodologyUrl = _config2.default.routes.companies + '#militaryweapons';
          fullProfileUrl = urlBuilder(_config2.default.links.wff, 'weapon-investments');
          fullProfileText = 'Weapon Free Funds';
          break;

        case 'tff':
          methodologyUrl = _config2.default.routes.companies + '#tobacco';
          fullProfileUrl = urlBuilder(_config2.default.links.tff, 'tobacco-profile');
          fullProfileText = 'Tobacco Free Funds';
          break;
      }

      return {
        methodologyUrl: methodologyUrl,
        fullProfileUrl: fullProfileUrl,
        fullProfileText: fullProfileText
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          methodologyUrl = _state.methodologyUrl,
          fullProfileUrl = _state.fullProfileUrl,
          fullProfileText = _state.fullProfileText;

      if (!fullProfileUrl || !fullProfileText) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        null,
        this.props.linkType === 'methodology' && methodologyUrl ? _react2.default.createElement(
          'div',
          { styleName: 'companies-methodology-link' },
          _react2.default.createElement(
            'span',
            null,
            'Methodology'
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _components.Link,
              {
                to: methodologyUrl,
                title: 'Methodology: How were these companies identified?',
                xstrong: true
              },
              'How were these companies identified?'
            )
          )
        ) : null,
        this.props.linkType === 'fullProfile' && fullProfileUrl ? _react2.default.createElement(
          'div',
          { styleName: 'companies-methodology-link' },
          _react2.default.createElement(
            'span',
            null,
            'Full results'
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _components.Link,
              {
                to: fullProfileUrl,
                title: fullProfileText,
                xstrong: true
              },
              'See full results for this fund at ',
              fullProfileText
            )
          )
        ) : null
      );
    }
  }]);
  return TargetDateSeriesMethodologyLink;
}(_react.Component), _class2.propTypes = {
  // three letters, fff/dff/gef/gff/pff/wff/tff
  iyvCode: _react.PropTypes.string.isRequired,
  // the target date series object
  targetDateSeries: _react.PropTypes.object.isRequired,
  // the type of link, methodology/fullProfile
  linkType: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = TargetDateSeriesMethodologyLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TargetDateSeriesMethodologyLink/TargetDateSeriesMethodologyLink.js
// module id = 1452
// module chunks = 0